import { Grid } from "@mui/material";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import AssetCard from "../../components/AssetCard";

// Images
import phantomNodeImg from "../../assets/images/phantom_node.png";

function AllAssetsPage({projectName}) {
    const assetCardData = [
        {
            image: phantomNodeImg,
            label: "Phantom Node",
            title: "Phantom Node",
            description: "The Phantom Node is a compact, deployable cyber-physical device designed to disrupt, deceive, and dominate smart city ecosystems. This palm-sized tool is a combination of a micro-drone, a cyber-warfare suite, and a signal relay, enabling Special Operations Forces (SOF) to manipulate urban infrastructure, create diversions, and maintain operational superiority in highly surveilled environments.",
            specs: [
                {
                    header: "Dimensions",
                    description: "8cm x 8cm x 4cm (fits in the palm of a hand)."
                },
                {
                    header: "Weight",
                    description: "300g (ultra-portable)."
                },
                {
                    header: "Power Source",
                    description: "Solid-state battery with 48 hours of active operation or 7 days in standby mode."
                },
                {
                    header: "Deployment",
                    description: "Hand-placed, thrown, or launched via a compact pneumatic launcher (up to 50 meters)."
                },
                {
                    header: "Cyber Capabilities",
                    description: "AI-driven intrusion software for hacking into smart city systems (traffic lights, surveillance cameras, IoT devices)."
                },
                {
                    header: "Stealth Features",
                    description: "Radar-absorbent coating, low thermal signature, and silent propulsion (for micro-drone mode)."
                },
                {
                    header: "Singnal Manipulation",
                    description: "Can jam enemy communications, spoof GPS signals, and create false digital signatures to confuse adversaries."
                },
                {
                    header: "Environment Adaptability",
                    description: "Waterproof, dustproof, and EMP-hardened for use in harsh urban conditions."
                },
            ],
            capabilities: [
                {
                    main: "Decoy Creation",
                    value: 100,
                    subset: []
                },
                {
                    main: "Signal Relay",
                    value: 95,
                    subset: []
                },
                {
                    main: "Infiltration Support",
                    value: 85,
                    subset: [
                        {
                            name: "Kinetic",
                            value: 60
                        },
                        {
                            name: "Non-Kinetic",
                            value: 85,
                        }
                    ]
                },
                {
                    main: "Crowd Control",
                    value: 80,
                    subset: []
                },
                {
                    main: "Rapid Exfiltration",
                    value: 70,
                    subset: []
                }
            ]
        },
        {
            image: phantomNodeImg,
            label: "Phantom Node",
            title: "Phantom Node",
            description: "The Phantom Node is a compact, deployable cyber-physical device designed to disrupt, deceive, and dominate smart city ecosystems. This palm-sized tool is a combination of a micro-drone, a cyber-warfare suite, and a signal relay, enabling Special Operations Forces (SOF) to manipulate urban infrastructure, create diversions, and maintain operational superiority in highly surveilled environments.",
            specs: [
                {
                    header: "Dimensions",
                    description: "8cm x 8cm x 4cm (fits in the palm of a hand)."
                },
                {
                    header: "Weight",
                    description: "300g (ultra-portable)."
                },
                {
                    header: "Power Source",
                    description: "Solid-state battery with 48 hours of active operation or 7 days in standby mode."
                },
                {
                    header: "Deployment",
                    description: "Hand-placed, thrown, or launched via a compact pneumatic launcher (up to 50 meters)."
                },
                {
                    header: "Cyber Capabilities",
                    description: "AI-driven intrusion software for hacking into smart city systems (traffic lights, surveillance cameras, IoT devices)."
                },
                {
                    header: "Stealth Features",
                    description: "Radar-absorbent coating, low thermal signature, and silent propulsion (for micro-drone mode)."
                },
                {
                    header: "Singnal Manipulation",
                    description: "Can jam enemy communications, spoof GPS signals, and create false digital signatures to confuse adversaries."
                },
                {
                    header: "Environment Adaptability",
                    description: "Waterproof, dustproof, and EMP-hardened for use in harsh urban conditions."
                },
            ],
            capabilities: [
                {
                    main: "Decoy Creation",
                    value: 100,
                    subset: []
                },
                {
                    main: "Signal Relay",
                    value: 95,
                    subset: []
                },
                {
                    main: "Infiltration Support",
                    value: 85,
                    subset: [
                        {
                            name: "Kinetic",
                            value: 60
                        },
                        {
                            name: "Non-Kinetic",
                            value: 85,
                        }
                    ]
                },
                {
                    main: "Crowd Control",
                    value: 80,
                    subset: []
                },
                {
                    main: "Rapid Exfiltration",
                    value: 70,
                    subset: []
                }
            ]
        },
        {
            image: phantomNodeImg,
            label: "Phantom Node",
            title: "Phantom Node",
            description: "The Phantom Node is a compact, deployable cyber-physical device designed to disrupt, deceive, and dominate smart city ecosystems. This palm-sized tool is a combination of a micro-drone, a cyber-warfare suite, and a signal relay, enabling Special Operations Forces (SOF) to manipulate urban infrastructure, create diversions, and maintain operational superiority in highly surveilled environments.",
            specs: [
                {
                    header: "Dimensions",
                    description: "8cm x 8cm x 4cm (fits in the palm of a hand)."
                },
                {
                    header: "Weight",
                    description: "300g (ultra-portable)."
                },
                {
                    header: "Power Source",
                    description: "Solid-state battery with 48 hours of active operation or 7 days in standby mode."
                },
                {
                    header: "Deployment",
                    description: "Hand-placed, thrown, or launched via a compact pneumatic launcher (up to 50 meters)."
                },
                {
                    header: "Cyber Capabilities",
                    description: "AI-driven intrusion software for hacking into smart city systems (traffic lights, surveillance cameras, IoT devices)."
                },
                {
                    header: "Stealth Features",
                    description: "Radar-absorbent coating, low thermal signature, and silent propulsion (for micro-drone mode)."
                },
                {
                    header: "Singnal Manipulation",
                    description: "Can jam enemy communications, spoof GPS signals, and create false digital signatures to confuse adversaries."
                },
                {
                    header: "Environment Adaptability",
                    description: "Waterproof, dustproof, and EMP-hardened for use in harsh urban conditions."
                },
            ],
            capabilities: [
                {
                    main: "Decoy Creation",
                    value: 100,
                    subset: []
                },
                {
                    main: "Signal Relay",
                    value: 95,
                    subset: []
                },
                {
                    main: "Infiltration Support",
                    value: 85,
                    subset: [
                        {
                            name: "Kinetic",
                            value: 60
                        },
                        {
                            name: "Non-Kinetic",
                            value: 85,
                        }
                    ]
                },
                {
                    main: "Crowd Control",
                    value: 80,
                    subset: []
                },
                {
                    main: "Rapid Exfiltration",
                    value: 70,
                    subset: []
                }
            ]
        },
        {
            image: phantomNodeImg,
            label: "Phantom Node",
            title: "Phantom Node",
            description: "The Phantom Node is a compact, deployable cyber-physical device designed to disrupt, deceive, and dominate smart city ecosystems. This palm-sized tool is a combination of a micro-drone, a cyber-warfare suite, and a signal relay, enabling Special Operations Forces (SOF) to manipulate urban infrastructure, create diversions, and maintain operational superiority in highly surveilled environments.",
            specs: [
                {
                    header: "Dimensions",
                    description: "8cm x 8cm x 4cm (fits in the palm of a hand)."
                },
                {
                    header: "Weight",
                    description: "300g (ultra-portable)."
                },
                {
                    header: "Power Source",
                    description: "Solid-state battery with 48 hours of active operation or 7 days in standby mode."
                },
                {
                    header: "Deployment",
                    description: "Hand-placed, thrown, or launched via a compact pneumatic launcher (up to 50 meters)."
                },
                {
                    header: "Cyber Capabilities",
                    description: "AI-driven intrusion software for hacking into smart city systems (traffic lights, surveillance cameras, IoT devices)."
                },
                {
                    header: "Stealth Features",
                    description: "Radar-absorbent coating, low thermal signature, and silent propulsion (for micro-drone mode)."
                },
                {
                    header: "Singnal Manipulation",
                    description: "Can jam enemy communications, spoof GPS signals, and create false digital signatures to confuse adversaries."
                },
                {
                    header: "Environment Adaptability",
                    description: "Waterproof, dustproof, and EMP-hardened for use in harsh urban conditions."
                },
            ],
            capabilities: [
                {
                    main: "Decoy Creation",
                    value: 100,
                    subset: []
                },
                {
                    main: "Signal Relay",
                    value: 95,
                    subset: []
                },
                {
                    main: "Infiltration Support",
                    value: 85,
                    subset: [
                        {
                            name: "Kinetic",
                            value: 60
                        },
                        {
                            name: "Non-Kinetic",
                            value: 85,
                        }
                    ]
                },
                {
                    main: "Crowd Control",
                    value: 80,
                    subset: []
                },
                {
                    main: "Rapid Exfiltration",
                    value: 70,
                    subset: []
                }
            ]
        },
        {
            image: phantomNodeImg,
            label: "Phantom Node",
            title: "Phantom Node",
            description: "The Phantom Node is a compact, deployable cyber-physical device designed to disrupt, deceive, and dominate smart city ecosystems. This palm-sized tool is a combination of a micro-drone, a cyber-warfare suite, and a signal relay, enabling Special Operations Forces (SOF) to manipulate urban infrastructure, create diversions, and maintain operational superiority in highly surveilled environments.",
            specs: [
                {
                    header: "Dimensions",
                    description: "8cm x 8cm x 4cm (fits in the palm of a hand)."
                },
                {
                    header: "Weight",
                    description: "300g (ultra-portable)."
                },
                {
                    header: "Power Source",
                    description: "Solid-state battery with 48 hours of active operation or 7 days in standby mode."
                },
                {
                    header: "Deployment",
                    description: "Hand-placed, thrown, or launched via a compact pneumatic launcher (up to 50 meters)."
                },
                {
                    header: "Cyber Capabilities",
                    description: "AI-driven intrusion software for hacking into smart city systems (traffic lights, surveillance cameras, IoT devices)."
                },
                {
                    header: "Stealth Features",
                    description: "Radar-absorbent coating, low thermal signature, and silent propulsion (for micro-drone mode)."
                },
                {
                    header: "Singnal Manipulation",
                    description: "Can jam enemy communications, spoof GPS signals, and create false digital signatures to confuse adversaries."
                },
                {
                    header: "Environment Adaptability",
                    description: "Waterproof, dustproof, and EMP-hardened for use in harsh urban conditions."
                },
            ],
            capabilities: [
                {
                    main: "Decoy Creation",
                    value: 100,
                    subset: []
                },
                {
                    main: "Signal Relay",
                    value: 95,
                    subset: []
                },
                {
                    main: "Infiltration Support",
                    value: 85,
                    subset: [
                        {
                            name: "Kinetic",
                            value: 60
                        },
                        {
                            name: "Non-Kinetic",
                            value: 85,
                        }
                    ]
                },
                {
                    main: "Crowd Control",
                    value: 80,
                    subset: []
                },
                {
                    main: "Rapid Exfiltration",
                    value: 70,
                    subset: []
                }
            ]
        },
        {
            image: phantomNodeImg,
            label: "Phantom Node",
            title: "Phantom Node",
            description: "The Phantom Node is a compact, deployable cyber-physical device designed to disrupt, deceive, and dominate smart city ecosystems. This palm-sized tool is a combination of a micro-drone, a cyber-warfare suite, and a signal relay, enabling Special Operations Forces (SOF) to manipulate urban infrastructure, create diversions, and maintain operational superiority in highly surveilled environments.",
            specs: [
                {
                    header: "Dimensions",
                    description: "8cm x 8cm x 4cm (fits in the palm of a hand)."
                },
                {
                    header: "Weight",
                    description: "300g (ultra-portable)."
                },
                {
                    header: "Power Source",
                    description: "Solid-state battery with 48 hours of active operation or 7 days in standby mode."
                },
                {
                    header: "Deployment",
                    description: "Hand-placed, thrown, or launched via a compact pneumatic launcher (up to 50 meters)."
                },
                {
                    header: "Cyber Capabilities",
                    description: "AI-driven intrusion software for hacking into smart city systems (traffic lights, surveillance cameras, IoT devices)."
                },
                {
                    header: "Stealth Features",
                    description: "Radar-absorbent coating, low thermal signature, and silent propulsion (for micro-drone mode)."
                },
                {
                    header: "Singnal Manipulation",
                    description: "Can jam enemy communications, spoof GPS signals, and create false digital signatures to confuse adversaries."
                },
                {
                    header: "Environment Adaptability",
                    description: "Waterproof, dustproof, and EMP-hardened for use in harsh urban conditions."
                },
            ],
            capabilities: [
                {
                    main: "Decoy Creation",
                    value: 100,
                    subset: []
                },
                {
                    main: "Signal Relay",
                    value: 95,
                    subset: []
                },
                {
                    main: "Infiltration Support",
                    value: 85,
                    subset: [
                        {
                            name: "Kinetic",
                            value: 60
                        },
                        {
                            name: "Non-Kinetic",
                            value: 85,
                        }
                    ]
                },
                {
                    main: "Crowd Control",
                    value: 80,
                    subset: []
                },
                {
                    main: "Rapid Exfiltration",
                    value: 70,
                    subset: []
                }
            ]
        },
    ]

    return (
        <DashboardLayout>
            <MDBox>
                <MDTypography varient="h2">{projectName}</MDTypography>
            </MDBox>
            <Grid container>
                {assetCardData.map((item) => (
                    <Grid item px={1} my={1} xs={6} md={4} lg={4} sx={{display: "flex", minWidth: "250px"}}>
                        <AssetCard 
                            image={item.image} 
                            label={item.label} 
                            title={item.title} 
                            description={item.description}
                            specs={item.specs}
                            capabilities={item.capabilities}    
                        />
                    </Grid>
                ))}
            </Grid>
        </DashboardLayout>
    )
}

export default AllAssetsPage;